import React from 'react';
import PopularCategories from '../../components/PopularCategories';

const Popular = () => {
  return (
    <div className="home-page">
      <PopularCategories/>
    </div>
  );
};

export default Popular;